/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

//import { IObrienTabbedContainerData } from './obrien-tabbed-container.data';
import { IObrienTabbedContainerProps, IObrienTabbedContainerConfig } from './obrien-tabbed-container.props.autogenerated';

export interface IObrienTabbedContainerViewProps extends IObrienTabbedContainerProps<IObrienTabbedContainerConfig> {

    tabTitle1?: string;
    tabTitle2?: string;

    tab1categories: React.ReactNode;
    tab2categories: React.ReactNode[];

}

/**
 *
 * ObrienTabbedContainer component
 * @extends {React.PureComponent<IObrienTabbedContainerProps<IObrienTabbedContainerConfig>>}
 */
class ObrienTabbedContainer extends React.PureComponent<IObrienTabbedContainerProps<IObrienTabbedContainerConfig>> {
    public render(): JSX.Element | null {

        const { config } = this.props;

        const TabTitle1 = config.tabTitle1 ? config.tabTitle1 : 'No Content';
        const TabTitle2 = config.tabTitle2 ? config.tabTitle2 : 'No Content';

        


        const viewprops = {
            ...this.props,
            tabTitle1: TabTitle1,
            tabTitle2: TabTitle2,
            tab1categories: this.props.slots.tabSlot1,
            tab2categories: this.props.slots.tabSlot2,
        };



        return this.props.renderView(viewprops);
    }
}

export default ObrienTabbedContainer;
